// extracted by mini-css-extract-plugin
module.exports = {"mobile_section":"styles_mobile_section__kCN5p","slideUp":"styles_slideUp__CsAcm"};